import * as React from "react";
import { formatStrings } from "../../../utils/time";
import { Table } from "../../../newcomponents/table/table";
import { TableHeaderRefreshButton } from "../../../newcomponents/table/components/RefreshButton";
import { DateStringColumn } from "../../../newcomponents/table/columns/generic/dateString";
import { InternalLink } from "../../../newcomponents/table/components/InternalLink";
import { BasePathContext } from "../../../reactContexts/basePathContext";
import { Loader, Plus } from "react-feather";
import { useDebounce } from "../../table/useDebounce";
import { useInitCommandsContext } from "./commandsContext";
import { Button, Input } from "antd";
import { ViewModal } from "../../modals/viewModal";

interface Props {
  selfLink: string;
}
export const Commands: React.FC<Props> = ({ selfLink }) => {
  const basePath = React.useContext(BasePathContext);

  const [search, setSearch] = React.useState("");
  const [debouncedSearch, setDebouncedSearch] = useDebounce(search, 300);
  const [isViewingCommands, setIsViewingCommands] = React.useState(false);
  React.useEffect(() => {
    setDebouncedSearch(search);
  }, [search]);
  React.useEffect(() => {
    if (debouncedSearch) {
      fetchCommandsQuery(debouncedSearch);
    } else {
      fetchCommandsPage(true);
    }
  }, [debouncedSearch]);

  const {
    commands,
    fetchCommandsPage,
    fetchCommandsQuery,
    commandsError: error,
    commandsNextLink: nextLink,
    commandsLoading: isLoading,
  } = useInitCommandsContext(selfLink);

  return (
    <div className="pb-16">
      {isViewingCommands && (
        <ViewModal
          kind="command"
          link={`${selfLink}/-command`}
          onClose={() => setIsViewingCommands(false)}
          title="Commands"
          visible={isViewingCommands}
          filename="commands"
        />
      )}
      <Table<any>
        title={"Commands"}
        data={commands}
        tableId={`${selfLink}-commands-update1`}
        headerRenderer={() => {
          return (
            <>
              <Input
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                placeholder="Search"
                style={{ width: 300 }}
              />
              <Button type="default" onClick={() => setIsViewingCommands(true)}>
                View Commands
              </Button>
              <TableHeaderRefreshButton onClick={() => fetchCommandsPage(true)} />
            </>
          );
        }}
        enableFilter={false}
        hideSettings
        isLoading={isLoading}
        columns={[
          {
            id: "id",
            label: "Command Id",
            enableResize: true,
            size: 200,
            cell: ({ row }) => {
              const command = row.original;
              return (
                <div className="flex flex-col justify-center" style={{ height: 56 }}>
                  <InternalLink label={command.id} to={`${basePath}/commands/${command.id}`} />
                </div>
              );
            },
          },
          {
            id: "name",
            label: "Name",
            enableResize: true,
            size: 150,
            accessorFn: (row) => row.tags?.name,
            cell: ({ getValue }) => getValue() || "-",
          },
          { id: "type", label: "Type", cell: ({ getValue }) => getValue() || "-" },
          { id: "lifecycleStage", label: "Lifecycle Stage", cell: ({ getValue }) => getValue() || "-" },
          {
            id: "messages",
            label: "Messages",
            cell: ({ row }) => {
              const command = row.original;
              const messages: string[] = command.status?.messages || [];
              return <div> {messages.length > 0 ? `${messages.length} Messages` : "-"}</div>;
            },
          },
          DateStringColumn({ id: "created" }, { format: formatStrings.log }),
        ]}
      />
      {nextLink ? (
        <Button
          type={`default`}
          block
          onClick={() => {
            if (!isLoading) {
              fetchCommandsPage();
            }
          }}
          disabled={isLoading}
        >
          <div className="flex items-center gap-2">
            {isLoading ? <Loader className="animate-spin" /> : <Plus />}
            {isLoading ? <div>Loading More Items</div> : <span>Load More Commands</span>}
          </div>
        </Button>
      ) : null}
    </div>
  );
};
